"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniteCallbacks = void 0;
var general_utils_1 = require("./general-utils");
var uniteCallbacks = function (callbacks) {
    return function () {
        general_utils_1.removeDuplicates(callbacks).forEach(function (cb) {
            cb();
        });
    };
};
exports.uniteCallbacks = uniteCallbacks;
//# sourceMappingURL=callback-utils.js.map